import React, { useState } from 'react'
import Select from 'react-select'
import { FaHandHolding } from 'react-icons/fa'
import Creatable from 'react-select/creatable'
import { Link, Route, Switch } from 'react-router-dom'
import { DatePicker, Menu, Dropdown } from 'antd'
import { useSelector } from 'react-redux'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { stringifyDate, useListData, useToggle, usePet } from '../../modules'

import Receive from '../../components/reusable/receive'
import Patient from '../../components/reusable/patient'

import PatientDetails from '../../components/drawers/patient'
import Admission from '../../components/drawers/admission'
import AdmitPatient from '../../components/drawers/admitPatient'
import Requests from '../../components/drawers/requests'
import NewWard from '../../components/modals/newWard'

const { RangePicker } = DatePicker

const Admissions = () => {
    const [ranges, setRanges] = useState()
    const [chosen, setChosen] = useState([])
    const [wards, setWards] = useState([])
    const [ward, setWard] = useState({ label: 'All', value: 'All' })
    const [string, setString] = useState('')
    const [pendingForwards, setFCount] = useState(0)
    const [ref, setRef] = useState()
    const [wardName, setWardName] = useState()

    const [select, toggleSelect] = useToggle()
    const [newWard, toggleNewWard] = useToggle()

    const { user } = useSelector(state => state.application)

    const [, getWards] = usePet('wards', { active: true, limit: 50 }, {
        notify: true, callback: ({ data }) => {
            let wrds = [{ label: 'All', value: 'All' }, ...data.wards.map(ward => ({ label: ward.name, value: ward._id, ...ward }))]
            setWards(wrds)

            if (wrds.length > 0)
                setWard(wrds[0])
        }
    })

    const [
        { loading: aLoading, error: aError, fetch: fetchAdmissions },
        { list: admissions },
        { page = 1, limit = 10, navigate, Paginate }
    ] = useListData('admissions', ranges ? {
        type: 'Admitted',
        string,
        ward: ward?._id,
        order: -1,
        from: ranges[0]?._d ?? null,
        to: ranges[1]?._d ?? null
    } : { type: 'Admitted', order: -1, string, ward: ward?._id, }, { notify: true })

    usePet('pointOfSaleItems', { category: 'Admissions', string: 'Admission' }, {
        notify: true, callback: ({ data }, notify, ops) => {
            if (data.items.length === 0) {
                notify('Admission module not initialized, please contact admin', ops('error'))
                return
            }

            setRef(data.items[0])
        }
    })

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const refresh = () => {
        navigate(1)
        fetchAdmissions()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const selectWard = ward => {
        setWard(ward)
        fetchAdmissions()
    }

    const createNewWard = name => {
        setWardName(name)
        toggleNewWard()
    }

    const onCreateWard = data => {
        setWard(({ label: data.name, value: data._id, ...data }))
        getWards()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {/* Modals */}
            {
                newWard &&
                <NewWard
                    visible={newWard}
                    name={wardName}
                    onPerform={onCreateWard}
                    toggle={toggleNewWard} />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Patient Name, OP/IP No." />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <RangePicker onChange={selectRange} />
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={() => null}>Patient Visits</Menu.Item>
                            </Menu>
                        }>
                        <button className="btn hisani-btn-green-light text-white">
                            <span className="hidden xs:block mr-2">Reports</span>
                            <AiOutlineDown />
                        </button>
                    </Dropdown>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <span>
                        <h2 className="font-semibold text-gray-800 mb-1">Admissions</h2>
                    </span>
                    <span className="flex items-center justify-between">
                        {
                            user?.issuperuser ?
                                <Creatable
                                    value={ward}
                                    onChange={selectWard}
                                    onCreateOption={createNewWard}
                                    styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                    options={wards}
                                    placeholder="Select Or Add New Ward" />
                                :
                                <Select
                                    value={ward}
                                    onChange={selectWard}
                                    styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                    options={wards}
                                    placeholder="Select Ward" />
                        }
                        <button onClick={refresh} className="btn ml-2 py-2.5 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                        <Link to="/app/inpatient/admissions/new">
                            <button className="btn ml-2 py-2.1 hisani-btn-green-light text-white">Admit Patient</button>
                        </Link>
                        <Link className="ml-2" to={`/app/inpatient/admissions/requests`}>
                            <button className="btn hisani-btn-green-light text-white flex items-center justify-between">
                                <FaHandHolding />
                                <span className="xs:block ml-2">Requests</span>
                            </button>
                        </Link>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={aLoading}
                        error={aError}>
                        {
                            admissions?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient Name</div>
                                                </th>
                                                {
                                                    ward?.label === 'All' &&
                                                    <th className="p-2">
                                                        <div className="font-semibold text-left">Ward</div>
                                                    </th>
                                                }
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Tmeline</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                admissions.map((item, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                {
                                                                    select ?
                                                                        <input
                                                                            onChange={() => choose(item._id)}
                                                                            checked={chosen.includes(item._id)}
                                                                            type="checkbox"
                                                                            className="form-checkbox cursor-pointer h-5 w-5" />
                                                                        :
                                                                        `${((page - 1) * limit) + (key + 1)}.`
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Patient patient={item.patient} />
                                                        </td>
                                                        {
                                                            ward?.label === 'All' &&
                                                            <th className="p-2 text-left">
                                                                <div className="font-normal">{ item?.name }</div>
                                                                { item?.indicator && <p className="text-gray-500 mb-0">{ item?.indicator }</p> }
                                                            </th>
                                                        }
                                                        <td className="p-2">
                                                            <div className="flex space-x-2 pl-1 items-center">
                                                                <div className={`w-2 h-2 rounded-full bg-${item.seen ? 'gray' : 'yellow'}-500 shadow`}></div>
                                                                <p className={`text-${item.seen ? 'gray' : 'yellow'}-500 text-xs italic mb-0`}>{item.seen ? 'Discharged' : 'Admitted'}</p>
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            {
                                                                item.served &&
                                                                <p className="text-gray-500 text-xs italic mb-0">Admitted on {stringifyDate(item.servedOn)} by {item.servedBy?.name}</p>
                                                            }
                                                            {
                                                                item.seen &&
                                                                <p className="text-gray-500 text-xs italic mb-0">Discharged on {stringifyDate(item.seenOn)} by {item.seenBy?.name}</p>
                                                            }
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Link to={`/app/inpatient/admissions/${item._id}`}><Menu.Item>View Record</Menu.Item></Link>
                                                                        <Link to={`/app/inpatient/admissions/patients/${item.patient?._id}`}><Menu.Item>Patient Details</Menu.Item></Link>
                                                                        <Menu.Item onClick={() => null}>Forward Patient</Menu.Item>
                                                                        {
                                                                            !item.filled &&
                                                                            <Menu.Item onClick={() => null}>{item.discarded ? 'Restore' : 'Discard'}</Menu.Item>
                                                                        }
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">No admission records {string.trim().length > 2 ? `matching "${string}"` : ""} were found</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
            <Switch>
                <Route path="/app/inpatient/admissions/new">
                    <AdmitPatient onCreate={onCreateWard} onClose={refresh} />
                </Route>
                <Route path="/app/inpatient/admissions/requests">
                    <Requests department="Admissions" path="/app/inpatient/admissions" />
                </Route>
                <Route path="/app/inpatient/admissions/patients/:id">
                    <PatientDetails reload={refresh} source="/app/inpatient/admissions" />
                </Route>
                <Route path="/app/inpatient/admissions/:id">
                    <Admission path="admissions" onClose={refresh} />
                </Route>
            </Switch>
        </div>
    )
}

export default Admissions